export const isIos = () =>
  [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod',
  ].indexOf(navigator.platform) !== -1 ||
  // iPad on iOS 13 detection
  (navigator.userAgent.indexOf('Mac') !== -1 && 'ontouchend' in document);

export const isSafari = () =>
  navigator.userAgent.indexOf('Safari') > -1 &&
  navigator.userAgent.indexOf('Chrome') === -1;

export const isAndroid = () => navigator.userAgent.indexOf('Android') > -1;
